import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./countDown.css";
import prize from "../../assets/prizepool.jpeg"; // Import the image

const CountDown = () => {
  const [days, setDays] = useState("00");
  const [hours, setHours] = useState("00");
  const [minutes, setMinutes] = useState("00");
  const [seconds, setSeconds] = useState("00");
  const [show, setShow] = useState(true);

  useEffect(() => {
    const countDownDate = new Date(2025, 1, 27, 23, 59, 59).getTime();

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;

      if (distance < 0) {
        clearInterval(interval);
        setShow(false);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setDays(days < 10 ? "0" + days : days.toString());
      setHours(hours < 10 ? "0" + hours : hours.toString());
      setMinutes(minutes < 10 ? "0" + minutes : minutes.toString());
      setSeconds(seconds < 10 ? "0" + seconds : seconds.toString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  if (!show) return <></>;

  return (
    <div
      id="countDown-container"
      className="px-6 py-10 sm:px-6 sm:py-8 h-auto max-w-screen-7xl mx-auto bg-black"
    >
      <div className="text-center p-6 bg-gradient-to-r from-teal-600 to-blue-500 text-white rounded-2xl shadow-2xl">
  <h2 className="inline-flex animated-text text-5xl lg:text-7xl font-extrabold text-yellow-300">
    🏆 15+ Internship Vouchers at Stake! 🎉
  </h2>

  <p className="text-3xl lg:text-5xl font-bold mt-4 text-white">
    💰 Worth <span className="text-6xl lg:text-7xl font-extrabold text-yellow-400">₹3K</span> Each!
  </p>

  <p className="text-lg lg:text-2xl text-gray-200 mt-4">
    Compete. Win. Unlock your future! 🚀💼
  </p>

  <p className="text-xl lg:text-3xl font-semibold mt-4 text-yellow-200">
    Internships at <span className="text-yellow-400">Emglitz Technologies</span> 🎯
  </p>

  {/* Button */}
  <MyButton />
</div>


      {/* Image Section */}
      <div className="flex justify-center my-6">
        <img 
          src={prize} 
          alt="Prize Pool" 
          className="max-w-full h-auto rounded-lg shadow-lg"
        />
      </div>

      {/* Countdown Section */}
      <h3 className="text-2xl lg:text-5xl pb-12 text-center text-white tracking-widest AstranovaHeroFont">
        <span className="text-4xl lg:text-6xl text-teal-500">C</span>ounter Until The Big Event
      </h3>
      <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 place-content-center gap-20">
        <li className="flex flex-col items-center text-white AstranovaHeroFont">
          <span className="text-7xl text-teal-500 tracking-widest">{days}</span>
          <div className="text-2xl tracking-wider">
            <span className="text-3xl text-teal-500">D</span>ays
          </div>
        </li>
        <li className="flex flex-col items-center text-white AstranovaHeroFont">
          <span className="text-7xl text-teal-500 tracking-widest">{hours}</span>
          <div className="text-2xl tracking-wider">
            <span className="text-3xl text-teal-500">H</span>ours
          </div>
        </li>
        <li className="flex flex-col items-center text-white AstranovaHeroFont">
          <span className="text-7xl text-teal-500 tracking-widest">{minutes}</span>
          <div className="text-2xl tracking-wider">
            <span className="text-3xl text-teal-500">M</span>inutes
          </div>
        </li>
        <li className="flex flex-col items-center text-white AstranovaHeroFont">
          <span className="text-7xl text-teal-500 tracking-widest">{seconds}</span>
          <div className="text-2xl tracking-wider">
            <span className="text-3xl text-teal-500">S</span>econds
          </div>
        </li>
      </ul>
    </div>
  );
};

// Corrected MyButton Component
const MyButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate("/events")}
      className="mt-6 px-8 py-4 bg-yellow-400 hover:bg-yellow-500 text-black text-2xl font-bold rounded-full shadow-lg transition transform hover:scale-110"
    >
      Participate & Win 🏅
    </button>
  );
};

export default CountDown;
